import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

const environment = import.meta.env.VITE_ENVIRONMENT;
const enabled = ['production', 'beta', 'development', 'demo'].includes(
  environment
);

if (enabled) {
  Sentry.init({
    dsn: 'https://a7bcfb869b84495198747642bd9106e3@o4508361078734848.ingest.us.sentry.io/4508812945326080',
    integrations: [
      Sentry.reactRouterBrowserTracingIntegration({
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    environment,
    tracesSampleRate: 1,
    tracePropagationTargets: [/^\//, import.meta.env.VITE_API_URL],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    profileSessionSampleRate: 0.1,
    profileLifecycle: 'trace',
  });
}

export async function loadDeferredSentryIntegrations() {
  if (!enabled) {
    return;
  }

  const { browserProfilingIntegration, replayIntegration } =
    await import('./configs/sentryDeferredIntegrations');
  Sentry.addIntegration(replayIntegration());
  Sentry.addIntegration(browserProfilingIntegration());
}
